import classNames from "classnames";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={classNames(
        "t-bg-neutral-55 t-animate-pulse t-rounded-md",
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
